import {
  CookbookFilterDataConnectorApollo,
  CookbookMealListConnectorApollo,
} from '@front-activerse/common-components';
import CookbookFilterContainer from './CookbookFilterContainer';

// Both queries start together: the screen renders as soon as the filter data arrives, while the
// full meal list keeps loading in the background and is only needed to show the results.
const CookbookFilterPage = () => {
  return (
    <CookbookFilterDataConnectorApollo>
      {(cookbookFilterData) => (
        <CookbookMealListConnectorApollo>
          {({ meals }) => <CookbookFilterContainer {...cookbookFilterData} meals={meals} />}
        </CookbookMealListConnectorApollo>
      )}
    </CookbookFilterDataConnectorApollo>
  );
};

export default CookbookFilterPage;
